module.exports = __webpack_public_path__ + "static/img/davis_pictgrid11_800x729.e5f7df6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/davis_pictgrid11_800x729.jpg
// module id = stpR
// module chunks = 0